import React, { useMemo } from "react"

import moment from "moment-timezone"
import { useSelector } from "react-redux"

import { IOneVerifyCoverageResult } from "@common-shared/types/responseData/oneVerifyResponseData.types"

import { CHECKER_CONFIG } from "../../config/checker.config"
import { GENERAL_CONFIG } from "../../config/general.config"
import { HtmlHelper } from "../../helpers/html.helper"
import { PoliciesHelper } from "../../helpers/policies.helper"
import { policiesSelector } from "../../store/selectors/policies.selector"

export const LastCheckedBadgeElement: React.FunctionComponent<{
    coverageResult: IOneVerifyCoverageResult
}> = props => {
    const { selectedItemHistory } = useSelector(policiesSelector)

    const isActivePlanStatus = useMemo<boolean>(() => {
        return (
            !!props.coverageResult.planStatus &&
            CHECKER_CONFIG.activePlanStatuses.includes(
                props.coverageResult.planStatus,
            )
        )
    }, [props.coverageResult])

    const isLatestCheck = useMemo<boolean>(() => {
        return PoliciesHelper.isLatestCheck(
            props.coverageResult.resultId,
            selectedItemHistory,
        )
    }, [props.coverageResult.resultId, selectedItemHistory])

    return HtmlHelper.getHtmlWrappedBadge(
        `${isLatestCheck ? "Last " : ""}Checked: ${moment(
            props.coverageResult.createdAt,
        ).format(GENERAL_CONFIG.defaultMomentDateFormat)}`,
        undefined,
        undefined,
        undefined,
        isActivePlanStatus
            ? "bg-brand-lilacLight border-brand-lilac"
            : undefined,
    )
}
